import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

import { useHistory } from 'react-router-dom'

import { Box, Button, Grid, Typography } from '@material-ui/core'

import useSnackbar from 'hooks/useSnackbar'
import helpers from 'helpers'

import {
  DashboardChartPaper,
  DashboardNumberCard,
  DonutChart,
  LinearProgressTable,
  LoadingFeedback,
} from 'components'

import { routes } from 'Routes'
import * as service from 'service'
import constants from 'constants/index'

const DashboardActivities = ({ onlyMine }) => {
  const { KANBAN_COLUMN_ROLE_FINALIZED } = constants.activities

  const history = useHistory()
  const snackbar = useSnackbar()
  const [stats, setStats] = useState(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true)
        const response = await service.dponet.kanbanTasks.stats(
          onlyMine ? { mine: true } : {},
        )
        setStats(response.data)
      } catch (error) {
        snackbar.open({
          message: helpers.formatters.errorMessage(error),
          variant: 'error',
        })
      } finally {
        setLoading(false)
      }
    }
    load()
    // eslint-disable-next-line
  }, [onlyMine])

  const maxCount = stats?.byDepartment?.[0]?.count || 1
  const departmentRows = (stats?.byDepartment || []).map((dept) => ({
    name: dept.name,
    value: dept.count,
    percentage: (dept.count / maxCount) * 100,
  }))

  const allByStatus = stats?.byStatus || []
  const finalized = allByStatus.filter(
    (s) => s.role === KANBAN_COLUMN_ROLE_FINALIZED,
  )
  const others = allByStatus.filter(
    (s) => s.role !== KANBAN_COLUMN_ROLE_FINALIZED,
  )
  const byStatus = [...others.slice(0, 5), ...finalized]

  const donutNames = byStatus.map((s) =>
    s.title.length > 23 ? s.title.slice(0, 23) + '…' : s.title,
  )
  const donutValues = byStatus.map((s) => s.count)
  const donutColors = byStatus.map((s) => s.color)

  return (
    <>
      <LoadingFeedback open={loading} />
      <Grid item xs={12}>
        <Typography variant="h4" color="primary">
          {onlyMine ? 'Minhas Atividades' : 'Atividades'}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <DashboardNumberCard
          label="Total de Atividades"
          value={stats?.total ?? 0}
          isLoading={loading}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <LinearProgressTable
          title="Departamentos com mais Atividades"
          rows={loading ? [] : departmentRows}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <DashboardChartPaper
          title="Atividades por Colunas"
          isLoading={loading}
          noMaxHeight
        >
          <DonutChart
            names={donutNames}
            values={donutValues}
            colors={donutColors}
            title="Atividades"
            id={`activities-status-donut${onlyMine ? '-mine' : ''}`}
            centerNameMaxChars={12}
          />
          <Box display="flex" justifyContent="flex-start" px={1}>
            <Button
              variant="text"
              size="small"
              onClick={() => history.push(routes.activitiesPanel.all)}
            >
              Ver mais
            </Button>
          </Box>
        </DashboardChartPaper>
      </Grid>
    </>
  )
}

DashboardActivities.propTypes = {
  onlyMine: PropTypes.bool,
}

export default DashboardActivities
